import { gql } from '@apollo/client'

export const GET_MEDIA = gql`
  query Media($courseId: ID!, $enrollmentId: ID, $id: ID!) {
    media(courseId: $courseId, enrollmentId: $enrollmentId, id: $id) {
      fileUrl
    }
  }
`
